var _sodipodiNamedview, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownIconHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200mm",
    height: "200mm",
    viewBox: "0 0 200 200",
    id: "svg9015",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    sodipodiDocname: "icon3.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview9017",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDocumentUnits: "mm",
    showgrid: "false",
    inkscapeZoom: 0.72515432,
    inkscapeCx: 376.47159,
    inkscapeCy: 432.32177,
    inkscapeWindowWidth: 1920,
    inkscapeWindowHeight: 1005,
    inkscapeWindowX: -9,
    inkscapeWindowY: -9,
    inkscapeWindowMaximized: 1,
    inkscapeCurrentLayer: "layer1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9012"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13488-0",
    transform: "matrix(1.4285715,0,0,1.4285715,-70.382636,-180.50146)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect846-6-0-6-6",
    width: 20,
    height: 20,
    x: -196.35101,
    y: 69.267845,
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect846-6-0-6-0-1",
    width: 20,
    height: 20,
    x: -196.35101,
    y: 149.26784,
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect846-6-0-6-0-7-5",
    width: 20,
    height: 20,
    x: -216.35101,
    y: 89.267845,
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect846-6-0-6-8-6",
    width: 20,
    height: 20,
    x: -176.35101,
    y: 169.26784,
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect846-6-8-3",
    width: 20,
    height: 20,
    x: -176.35101,
    y: 49.267841,
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect846-6-0-6-0-4-7",
    width: 20,
    height: 20,
    x: -236.35101,
    y: 109.26785,
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "rect846-6-0-6-0-6-5",
    width: 20,
    height: 20,
    x: -216.35101,
    y: 129.26785,
    transform: "rotate(-90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIconHover);
export default __webpack_public_path__ + "static/media/dropdown-icon-hover.18430ffa58e0805e837a886b5d4bebb0.svg";
export { ForwardRef as ReactComponent };